export const FormFieldTypes = {
    INPUT: 1,
    PASSWORD: 2,
    NUMERIC: 3,
    CHECKBOX: 4,
    DATEPICKER: 5,
    SELECT: 6,
    TEXTAREA: 7,
    TEXTEDITOR: 8,
    FILE: 9,
    RADIOBUTTON: 10,
    EDITABLEDROPDOWN: 11,
    PHONE: 12,
    IMAGE: 13,
    TIME: 14,
    LAZY_SELECT: 15,
    TOGGLE: 16,
    RANGE_SLIDER: 17
    // SEPARATOR: 14,
    // MAINFORMTITLE: 15,
    // INPUTWITHBUTTON: 16,
    // INPUTWITHCONTROL: 17,
    // CUSTOMSELECT: 19
};
export const FileFormats = {
    PDF: '.pdf',
    DOC: '.doc',
    DOCX: '.docx',
    XLS: '.xls',
    XLSX: '.xlsx',
    TXT: '.txt',
    CSV: '.csv',
    PPT: '.ppt',
    PPTX: '.pptx',
    ZIP: '.zip',
    RAR: '.rar',
    ODT: '.odt',
    ODS: '.ods',
    ODP: '.odp',
    HTML: '.html',
    XML: '.xml',
    JSON: '.json',
    MD: '.md',
    RTF: '.rtf',
    LOG: '.log',
    ALL: '*',
};
export const ImageFormats = {
    JPEG: '.jpeg',
    JPG: '.jpg',
    PNG: '.png',
    GIF: '.gif',
    BMP: '.bmp',
    WEBP: '.webp',
    TIFF: '.tiff',
    SVG: '.svg',
    ICO: '.ico',
    ANY: ['.jpeg', '.jpg', '.png', '.gif', '.bmp', '.webp', '.tiff', '.svg', '.ico']
};